// Badge pill con i nomi degli studi AlfaDocs di un cliente (colonna "Studio"
// nelle viste tabella, visibile solo per org multi-studio). practiceIds è già
// ordinato con la practice primaria per prima (getClientStudioIds).
interface StudioBadgesProps {
  practiceIds: string[];
  studioNames: Map<string, string>; // practiceId → display_name (solo studi attivi)
}

export function StudioBadges({ practiceIds, studioNames }: StudioBadgesProps) {
  // Studi disconnessi (senza nome noto) non vengono renderizzati.
  const visible = practiceIds.filter((id) => studioNames.has(id));
  if (visible.length === 0) return <span className="text-[#787774] dark:text-white/40">—</span>;
  return (
    <div className="flex flex-wrap items-center gap-1">
      {visible.map((id) => (
        <span
          key={id}
          className="px-1.5 py-0.5 text-[10px] font-medium rounded bg-[#2383E2]/10 text-[#2383E2] dark:bg-[#529CCA]/15 dark:text-[#529CCA] whitespace-nowrap"
        >
          {studioNames.get(id)}
        </span>
      ))}
    </div>
  );
}
